module.exports = __webpack_public_path__ + "img/index-list-3.24db2942.png";